import { LOGIN_PATH, OIDC_CALLBACK_PATH } from "@airange/shared/oidc-routes";

export default [
  {
    path: LOGIN_PATH,
    layout: false,
    component: "./LoginPage",
  },
  {
    path: OIDC_CALLBACK_PATH,
    layout: false,
    component: "./OidcCallbackPage",
  },
  {
    path: "/",
    redirect: "/dashboard",
  },
  {
    path: "/dashboard",
    name: "eduDashboard",
    icon: "dashboard",
    access: "canAccessEduAdmin",
    component: "./DashboardPage",
  },
  {
    path: "/courses",
    name: "eduCourses",
    icon: "read",
    access: "canAccessEduAdmin",
    routes: [
      {
        path: "/courses",
        access: "canAccessEduAdmin",
        component: "./CoursesPage",
      },
      {
        path: "/courses/:courseId",
        name: "eduCourseDetail",
        access: "canAccessEduAdmin",
        hideInMenu: true,
        component: "./CourseDetailPage",
      },
    ],
  },
  {
    path: "/teaching-plans",
    name: "eduTeachingPlans",
    icon: "calendar",
    access: "canAccessEduAdmin",
    component: "./TeachingPlansPage",
  },
  {
    path: "/projects",
    name: "eduProjects",
    icon: "project",
    access: "canAccessEduAdmin",
    routes: [
      {
        path: "/projects",
        access: "canAccessEduAdmin",
        component: "./ProjectsPage",
      },
      {
        path: "/projects/:projectId/course-instances",
        name: "eduProjectsCourseInstances",
        access: "canAccessEduAdmin",
        hideInMenu: true,
        component: "./ProjectCourseInstancesPage",
      },
      {
        path: "/projects/:projectId/exam-results",
        name: "eduProjectsExamResults",
        access: "canAccessEduAdmin",
        hideInMenu: true,
        component: "./ProjectExamResultsPage",
      },
    ],
  },
  {
    path: "/public-courses",
    name: "eduPublicCourses",
    icon: "global",
    access: "canAccessEduAdmin",
    component: "./PublicCoursesPage",
  },
  {
    path: "/members",
    name: "eduMembers",
    icon: "team",
    access: "canAccessEduAdmin",
    component: "./MembersPage",
  },
  {
    path: "/orgs",
    name: "eduOrgs",
    icon: "apartment",
    access: "canAccessEduAdmin",
    component: "./OrgsPage",
  },
  {
    path: "*",
    component: "./NotFoundPage",
  },
];
